import classNames from 'classnames';
import { FC } from 'react';

import { IcVerification16Icon } from '@gem/icons';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import { Features } from 'APP/packages/features/Features';

import styles from './VerifiedBadge.styles.m.css';

interface IVerifiedBadgeProps {
  className?: string;
}

export const VerifiedBadge: FC<IVerifiedBadgeProps> = (props) => {
  if (!Features.isVerifiedBadgeEnabled()) {
    return null;
  }
  return (
    <IconView
      className={classNames(styles.verified, props.className)}
      size={IconViewSizes.Small}
      Icon={IcVerification16Icon}
    />
  );
};
